export const altWithComma = (itemOBJ, key, altKey) => {
    if (itemOBJ[altKey] != null && itemOBJ[altKey] != '') {
        return `${itemOBJ[altKey]}`;
    }

    return itemOBJ[key]

}

